module.exports = __webpack_public_path__ + "static/smb3_coin-e8613517813b0c304f51df0f766a2ef3.wav";